module.exports = __webpack_public_path__ + "img/xiao-deng.5480560b.png";